module.exports = __webpack_public_path__ + "img/Artboard – 4 (1).634b9416.png";